
import styleguide from '@hw-ui/styleguide/routes'
import components from '@hw-ui/ui/routes'
import unused from '@hw-ui/unused/routes'

const home = {
  menuItems: [{
    title: 'Home',
    icon: 'HomeIcon',
    route: 'hw-ui',
  }]
}

const styleguideItems = {
  header: {
    header: 'styleguide',
  },
  menuItems: [...styleguide.map(route => ({title: route.name, route: route.name, icon: 'ChevronRightIcon'}))]
}

const componentsItems = {
  header: {
    header: 'components in used',
  },
  menuItems: [...components.map(route => ({title: route.name, route: route.name, icon: 'ChevronRightIcon'}))]
}

const unusedComponents = {
  header: {
    header: 'unused components',
  },
  menuItems: [...unused.map(route => ({title: `${route.name} ${route.meta.unused ? '(unused)' : ''}`, route: route.name, icon: 'ChevronRightIcon'}))]
}

const vertical = [
  ...home.menuItems,
  styleguideItems.header,
  ...styleguideItems.menuItems,
  componentsItems.header,
  ...componentsItems.menuItems,
  unusedComponents.header,
  ...unusedComponents.menuItems
]

const horizontal = [
  ...home.menuItems,
  ...[styleguideItems, componentsItems, unusedComponents].reduce((acc, {header, menuItems}) => [...acc, {...header, children: menuItems}], [])
]

export default {vertical, horizontal}
